import Alpine from 'alpinejs';
import ajax from '@imacrayon/alpine-ajax';
import intersect from '@alpinejs/intersect';
import htmx from 'htmx.org';

// Register Alpine AJAX plugin
Alpine.plugin(ajax);

// Register Alpine Intersect plugin (x-intersect)
Alpine.plugin(intersect);

window.Alpine = Alpine;
window.htmx = htmx;

// Configure Alpine AJAX with WordPress nonce
document.addEventListener('alpine:init', () => {
    const wpNonce = window.wpApiSettings?.nonce || window.nonce;
    
    if (wpNonce) {
        // Configure Alpine AJAX headers
        Alpine.store('ajax', {
            headers: {
                'X-WP-Nonce': wpNonce,
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });
    }
});

// Configure HTMX if nonce is available
const wpNonce = window.wpApiSettings?.nonce || window.nonce;
if(wpNonce) {
    document.addEventListener('htmx:configRequest', function(event) {
        event.detail.headers['X-WP-Nonce'] = wpNonce;
    });
}

document.addEventListener('DOMContentLoaded', function() {
    Alpine.start();
});

// Expose the fixed header's height as --header-height on :root so CSS can
// offset for it (e.g. scroll-margin-top on scroll-to targets). The header is
// content-sized and taller on mobile, so it's measured live and kept in sync
// via ResizeObserver rather than hardcoded per breakpoint.
(function trackHeaderHeight() {
    const header = document.querySelector('header');
    if (!header) return;

    const setHeaderHeight = () => {
        document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);
    };

    setHeaderHeight();
    new ResizeObserver(setHeaderHeight).observe(header);
})();

// Gravity Forms textareas rest at one line and open on focus (forms.css). One
// with something typed in it has to STAY open, and CSS can't test a control's
// value — :not(:placeholder-shown) inverts on a textarea with no placeholder
// attribute, so it can't be trusted here. Flag filled ones instead and leave
// the sizing to the stylesheet.
(function markFilledTextareas() {
    const SELECTOR = '.gform_wrapper textarea';

    const mark = (el) => el.classList.toggle('has-content', el.value.trim() !== '');
    const markAll = () => document.querySelectorAll(SELECTOR).forEach(mark);

    // Delegated, so textareas on later pages of a multi-page form are covered
    // without rebinding.
    document.addEventListener('input', (e) => {
        if (e.target.matches(SELECTOR)) mark(e.target);
    });

    // Fields can arrive already populated — a validation error or
    // save-and-continue repopulates them with no input event. gform_post_render
    // fires after every render, AJAX page changes included; it's a jQuery event
    // and jQuery only exists on pages that have a form, hence the guard.
    markAll();
    window.jQuery?.(document).on('gform_post_render', markAll);
})();

// Alpine.magic('blockData', (el, { Alpine }) => {
//     // el.parentElement.id is the key of the blockData object
//     let blockData = Alpine.store('blockData')[el.parentElement.id];
//     return blockData;
// });